export const GET_FEATURE_TOGGLES_REQUEST = 'GET_FEATURE_TOGGLES_REQUEST';

export const GET_FEATURE_TOGGLES_SUCCESS = 'GET_FEATURE_TOGGLES_SUCCESS';

export const GET_FEATURE_TOGGLES_FAILURE = 'GET_FEATURE_TOGGLES_FAILURE';
